function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNnIconFlagsPlDelivery = function SvgNnIconFlagsPlDelivery(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Lager 54",
    viewBox: "0 0 50.47 33.81"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M.12.13h50.22v33.56H.12z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75 33.34v33.32H25V33.34zm.25-.25H24.77v33.82h50.46V33.09Z",
    style: {
      fill: "#87888a"
    },
    transform: "translate(-24.77 -33.09)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.25 16.91h49.97v16.66H.25z",
    style: {
      fill: "#f00014"
    }
  }));
};
export default SvgNnIconFlagsPlDelivery;